import { Roles } from '@/entities/roles'
import {
  AcceptDealDialog,
  AdaptiveDealBanner,
  DealHeader,
  TopupModel,
  useConfirmTopupDialog,
} from '@/entities/topup'
import { TopupStatus } from '@/entities/topups'
import { useTopupQuery } from '@/entities/topups/hooks/useTopupQuery'
import { USER_ROLE_KEY } from '@/features/auth'
import { useCreateDisput } from '@/features/orders/hooks/useCreateDisput'
import { useDisputModals } from '@/features/orders/hooks/useDisputModals'
import { useGetDisputData } from '@/features/orders/hooks/useGetDisputData'
import { CreateDisputeDialog } from '@/features/orders/ui/dialogs/CreateDisputDialog'
import { RequisiteBlock } from '@/features/requisites'
import { DeviceBlock } from '@/shared/components/DeviceBlock/DeviceBlock'
import { BasePageSkeleton } from '@/shared/components/Skeletones/BasePageSkeleton'
import { getStorageItem } from '@/shared/lib/storage/localStorage'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

export const DealPage = () => {
  const { id } = useParams<{ id: string }>()
  const [selectedTopupId, setSelectedTopupId] = useState<string>('')
  const userRole = getStorageItem<Roles | null>(USER_ROLE_KEY, null)

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const { queryTopupData, queryKey, topupError, topupIsLoading } = useTopupQuery({ id: id ?? '' })

  const { disputData, isLoading: disputDataIsLoading } = useGetDisputData({
    disputId: queryTopupData?.disputId ?? '',
  })

  const { modalVisible, setModalVisible, openDialog, submitDialog } = useConfirmTopupDialog({
    queryKey: queryKey,
    selectedTopupId,
  })

  const handleConfirmTopup = (id: string) => {
    openDialog()
    setSelectedTopupId(id)
  }

  // создание спора из заявки
  const { handlers, modalStates, modalSetters } = useDisputModals()
  const { handleCreateDisput, isPendingCreate } = useCreateDisput(handlers.closeCreateModal)

  const buttonIsVisible =
    queryTopupData?.status !== TopupStatus.Paid &&
    queryTopupData?.status !== TopupStatus.OverPaid &&
    queryTopupData?.status !== TopupStatus.PartiallyPaid

  return topupError ? (
    <p>Ошибка загрузки данных.</p>
  ) : topupIsLoading || disputDataIsLoading ? (
    <>
      <BasePageSkeleton />
    </>
  ) : !queryTopupData ? null : (
    <div className="flex flex-col gap-10">
      <div>
        <DealHeader
          data={queryTopupData}
          onConfirm={handleConfirmTopup}
          userRole={userRole}
          openModal={handlers.openCreateModal}
          buttonIsVisible={buttonIsVisible}
          disputId={queryTopupData?.disputId}
          disputData={disputData}
        />
        <AdaptiveDealBanner
          data={queryTopupData}
          onConfirm={handleConfirmTopup}
          userRole={userRole}
          openModal={handlers.openCreateModal}
          buttonIsVisible={buttonIsVisible}
          disputId={queryTopupData?.disputId}
          disputData={disputData}
        />
      </div>

      <RequisiteBlock userRole={userRole} data={queryTopupData} />

      {userRole === Roles.Trader && (
        <>
          <DeviceBlock id={(queryTopupData as TopupModel).deviceProfile.id} />
          <AcceptDealDialog
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            onSubmit={submitDialog}
          />
        </>
      )}

      <CreateDisputeDialog
        modalVisible={modalStates.isCreateDisputOpen}
        setModalVisible={modalSetters.setIsCreateDisputOpen}
        onSubmit={handleCreateDisput}
        isLoading={isPendingCreate}
        paymentIdFromProps={id}
      />
    </div>
  )
}
